import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  Input
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { item, MerchantItems } from "src/app/models/items";
import { GeneralService } from "src/app/services/general.service";
import { ProductCategories } from "../../models/categories";
import { CommunicationService } from "src/app/services/communication.service";
import { MockStoreService } from "src/app/services/mock-store.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-add-item",
  templateUrl: "./add-item.component.html",
  styleUrls: ["./add-item.component.css"]
})
export class AddItemComponent implements OnInit, OnChanges {
  @ViewChild("monthlyAmount") monthlyAmount: ElementRef;
  @ViewChild("monthsNumber") monthsNumber: ElementRef;
  @ViewChild("amount") amount: ElementRef;
  @ViewChild("upfrontPayments") upfrontPayments: ElementRef;
  @Input("itemToEdit") itemToEdit: MerchantItems = undefined;

  // itemsList: item[] = [];
  creditOptions: boolean = false;
  additionalProductInfo: boolean = false;
  createAnItemForm: FormGroup;
  productCategories: Array<{ id: string; value: string }> = [];
  primary_picture: string = "https://via.placeholder.com/43";
  secondary_picture: string = "https://via.placeholder.com/44";
  tertiary_picture: string = "https://via.placeholder.com/45";
  editMode: boolean = false;
  //  calculation variables
  noOfMonths: number = 0;
  calculatedRemittancePerMonth: number = 0;
  calculatedUpFrontPay: number = 0;
  calculate: boolean = false;
  //  ends here
  activeDiv: HTMLElement;
  arrayOfPictures: any[] = [];
  currentPictureInView: string;

  constructor(
    private mockstore: MockStoreService,
    private fb: FormBuilder,
    private commservice: CommunicationService,
    private generalservice: GeneralService
  ) {
    this.productCategories = ProductCategories().data;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.itemToEdit = changes.itemToEdit.currentValue;
    setTimeout(() => {
      this.fillUpFormAsEditModeIsOn(this.itemToEdit);
    }, 800);
  }
  ngOnInit(): void {
    this.createAnItemForm = this.fb.group({
      name: ["", Validators.required],
      category_id: ["", Validators.required],
      price: ["", Validators.required],
      fund_credit_merchant: [""],
      fund_credit_creditclan: [""],
      monthly_amount: [""],
      no_of_months: [""],
      no_of_months_upfront: [""],
      analysis_option: [""],
      data_option: [""],
      description: [""],
      discount: [""],
      primary_picture: [""],
      secondary_picture: [""],
      tertiary_picture: [""],
      delivery_info: [""]
    });

    // document.addEventListener("click", e => console.log(e));
    //  this function fires when a transition Event occurs
    // this function is neccessary because i want to put the functionality
    // for changing individual pictures on the slider;
    document
      .getElementById("transitionParent")
      .addEventListener("transitionend", (e: TransitionEvent) => {
        const activeDiv = (e.srcElement as HTMLElement).querySelector(
          ".owl-item.active"
        );
        this.activeDiv = activeDiv as HTMLElement;
        const idOfImgElement = activeDiv.querySelector("img").id;
        if (!idOfImgElement) return;
        this.currentPictureInView = idOfImgElement;
      });

    // this.price.valueChanges.subscribe(val => val);
    // this.no_of_months.valueChanges.subscribe(val => console.log(val));
    // this.no_of_months_upfront.valueChanges.subscribe(val => console.log(val))
  }

  get fund_credit_creditclan() {
    return this.createAnItemForm.get("fund_credit_creditclan");
  }

  get fund_credit_merchant() {
    return this.createAnItemForm.get("fund_credit_merchant");
  }

  get price() {
    return this.createAnItemForm.get("price");
  }

  get no_of_months() {
    return this.createAnItemForm.get("no_of_months");
  }

  get monthly_amount() {
    return this.createAnItemForm.get("monthly_amount");
  }

  get no_of_months_upfront() {
    return this.createAnItemForm.get("no_of_months_upfront");
  }
  doCalculation(event: Event) {
    if (!this.no_of_months.value || !this.no_of_months_upfront.value) {
      this.generalservice.warningNotification(
        `Cannot calculate the required payment amount because required fields are empty`
      );
      (this.monthsNumber.nativeElement as HTMLInputElement).classList.add(
        "borderRed"
      );
      (this.upfrontPayments.nativeElement as HTMLInputElement).classList.add(
        "borderRed"
      );
      return;
    }
    if (
      isNaN(this.no_of_months.value) ||
      isNaN(this.price.value) ||
      isNaN(this.no_of_months_upfront.value)
    ) {
      this.generalservice.warningNotification(
        `Cannot calculate the required payment amount because required fields are empty`
      );
      (this.amount.nativeElement as HTMLInputElement).classList.add(
        "borderRed"
      );
      (this.monthsNumber.nativeElement as HTMLInputElement).classList.add(
        "borderRed"
      );
      (this.upfrontPayments.nativeElement as HTMLInputElement).classList.add(
        "borderRed"
      );
      return;
    }

    if (this.no_of_months.value > 12 || this.no_of_months.value < 1) {
      this.generalservice.warningNotification(
        `Number of months cannot be more than 12`
      );
      (this.monthsNumber.nativeElement as HTMLInputElement).classList.add(
        "borderRed"
      );
      return;
    }

    this.noOfMonths = this.no_of_months.value;
    const total = this.price.value;
    this.calculatedUpFrontPay =
      this.monthly_amount.value * this.no_of_months_upfront.value;
    // then subtracct the no_of_months_upfront from this.noOfMOnths
    this.noOfMonths = this.noOfMonths - this.no_of_months_upfront.value;
    // the remaining remittances will be done by
    this.calculatedRemittancePerMonth = total - this.calculatedUpFrontPay;
    //  display the result
    this.calculate = true;
  }

  // toggles this form on or off
  toggleCreditOptionsForm(): void {
    this.creditOptions = !this.creditOptions;
  }

  // toggles this form on or off
  toggleAdditionalProductInfoForm() {
    this.additionalProductInfo = !this.additionalProductInfo;
  }

  // submits the addproduct form
  submitAddProductForm(form: FormGroup, event: Event) {
    if (event instanceof KeyboardEvent && event.code.includes("Enter")) {
      return;
    }
    if (!window.navigator.onLine) {
      this.generalservice.warningNotification(
        "You are offline. Please check your internet connection and try again"
      );
      return;
    }
    const currentForm = event.srcElement as HTMLFormElement;
    const button = currentForm.querySelector("button");
    if (this.arrayOfPictures.length < 3) {
      this.generalservice.warningNotification(
        `You haven't completely added pictures`
      );
      return;
    }

    let temp = {
      ...form.value
    };
    if (
      !this.fund_credit_creditclan.value &&
      !this.fund_credit_merchant.value
    ) {
      this.generalservice.warningNotification(
        `Please indicate if you want to fund the credit or if you want credit clan to take care of it`
      );
      return;
    }

    currentForm.style.opacity = "0.5";
    currentForm.style.pointerEvents = "none";
    button.innerText = this.editMode ? "MAKING CHANGES...." : "ADDING ITEM....";
    temp = {
      ...form.value
    };
    // console.log(temp);
    const formToSubmit = this.processFormForSubmission(temp);

    if (this.editMode) {
      this.handleEditedItem(form, currentForm, button);
      return;
    }

    this.commservice.additems(formToSubmit).subscribe(
      val => {
        this.manageResponse(val, form, currentForm, button);
      },
      err => {
        this.manageError(currentForm, form, button);
        this.generalservice.handleError(err);
      }
    );
  }

  uncheckAdjacentBoxes(event: Event) {
    const input = event.srcElement as HTMLInputElement;
    const id = input.id;
    switch (id) {
      case "customRadio1":
        (document.getElementById(
          "customRadio2"
        ) as HTMLInputElement).checked = false;
        break;
      case "customRadio2":
        (document.getElementById(
          "customRadio1"
        ) as HTMLInputElement).checked = false;
        break;
      case "customRadio3":
        (document.getElementById(
          "customRadio5"
        ) as HTMLInputElement).checked = false;
        break;
      case "customRadio5":
        (document.getElementById(
          "customRadio3"
        ) as HTMLInputElement).checked = false;
        break;
      case "customRadio6":
        (document.getElementById(
          "customRadio9"
        ) as HTMLInputElement).checked = false;
        break;
      case "customRadio9":
        (document.getElementById(
          "customRadio6"
        ) as HTMLInputElement).checked = false;
        break;
    }
  }

  getUrl(picture): string {
    let returnString;
    // "url('http://estringsoftware.com/wp-content/uploads/2017/07/estring-header-lowsat.jpg')"
    switch (picture) {
      case "tertiary_picture":
        returnString = `url(${this.tertiary_picture})`;
        break;
      case "primary_picture":
        returnString = `url(${this.primary_picture})`;
        break;
      case "secondary_picture":
        returnString = `url(${this.secondary_picture})`;
        break;
    }

    return returnString;
  }

  changePicture(event: Event) {
    const srcElement = event.srcElement as HTMLElement;
    if (srcElement.id == "changePicture") {
      event.stopImmediatePropagation();
      this.trigger();
    }
  }

  trigger(event?: Event) {
    if (event) {
      this.currentPictureInView = "primary_picture";
      this.activeDiv = document
        .getElementById(this.currentPictureInView)
        .closest(".owl-item") as HTMLElement;
    }
    (document.getElementById("inputFiles") as HTMLInputElement).click();
  }

  imageChanger(event) {
    // check the file the user is trying to upload is
    // more than 2.5mb. If it is, tell d user;
    if (event.target.files[0].size > 2000000) {
      this.generalservice.warningNotification(
        "Please upload pictures less than 2.0MB"
      );
    }

    if (!this.currentPictureInView) return;
    let pictureFile = event.target.files[0];
    let picture = {
      [`${this.currentPictureInView}`]: pictureFile
    };

    // this.arrayOfPictures = [...this.arrayOfPictures, picture];
    this.manageArrayOfPictures(picture);
    // console.log(this.arrayOfPictures);

    // console.log(event.target.files);
    let reader: FileReader;
    if (FileReader) {
      // check if the filereader api is supported by browser

      reader = new FileReader();
      reader.onload = event => {
        // let pictureInView = this.currentPictureInView;
        // if (!pictureInView) return;
        this.activeDiv.querySelector("img").src = `${event.target["result"]}`;
        let pictureInView = this.activeDiv.querySelector("img").id;
        this[pictureInView] = `${event.target["result"]}`;
        // imageToDisplay.src = `${event.target["result"]}`;
        // this.generalservice.familyImageToConfirm = event.target["result"];
        // this.uploaded = true;
      };
      reader.readAsDataURL(event.target.files[0]);
      // this.controlAnimation();
    }
  }

  manageArrayOfPictures(picture: { [x: string]: File }) {
    let name: string, index: number;
    if (this.arrayOfPictures.length < 3) {
      this.arrayOfPictures.push(picture);
    }
    name = Object.keys(picture)[0];
    index = this.arrayOfPictures.findIndex(element => {
      let thisName = Object.keys(element)[0];
      return thisName == name;
    });

    this.arrayOfPictures.splice(index, 1, picture);
  }

  handleEditedItem(
    form: FormGroup,
    currentForm: HTMLFormElement,
    button: HTMLButtonElement
  ) {
    const temp = { ...form.value };
    const formToSubmit = this.processFormForSubmission(temp);
    this.commservice
      .editItems(formToSubmit, this.itemToEdit.id.toString())
      .subscribe(
        val => this.manageResponse(val, form, currentForm, button),
        err => {
          this.manageError(currentForm, form, button);
          this.generalservice.handleError(err);
        }
      );
  }

  fillUpFormAsEditModeIsOn(itemToEdit: MerchantItems) {
    // console.log(itemToEdit, "i am here");
    if (itemToEdit) {
      this.createAnItemForm.patchValue(itemToEdit);
      this.primary_picture = this.itemToEdit.primary_picture;
      this.secondary_picture = this.itemToEdit.secondary_picture;
      this.tertiary_picture = this.itemToEdit.tertiary_picture;
      this.arrayOfPictures = [];
      this.arrayOfPictures.push({ primary_picture: this.primary_picture });
      this.arrayOfPictures.push({ secondary_picture: this.secondary_picture });
      this.arrayOfPictures.push({ tertiary_picture: this.tertiary_picture });

      // filling the value of the select box;
      const selectedCategory = this.productCategories.find(
        element => element.id == itemToEdit.category_id
      );
      (document.getElementById(
        "categorySelect"
      ) as HTMLSelectElement).selectedIndex = Number(selectedCategory.id);
      (document.getElementById("categorySelect") as HTMLSelectElement).value =
        selectedCategory.value;

      // analysis option

      if (itemToEdit.analysis_option == 0) {
        (document.getElementById(
          "customRadio9"
        ) as HTMLInputElement).checked = true;
      } else if (itemToEdit.analysis_option == 1) {
        (document.getElementById(
          "customRadio6"
        ) as HTMLInputElement).checked = true;
      }
      // ends here

      // data option
      if (itemToEdit.data_option == 0) {
        (document.querySelector(
          "#customRadio5"
        ) as HTMLInputElement).checked = true;
      } else if (itemToEdit.data_option == 1) {
        (document.querySelector(
          "#customRadio3"
        ) as HTMLInputElement).checked = true;
      }
      // ends here

      // fund Option
      if (itemToEdit.fund_option == 0) {
        (document.querySelector(
          "#customRadio1"
        ) as HTMLInputElement).checked = true;
        this.fund_credit_merchant.patchValue("1");
      } else if (itemToEdit.fund_option == 1) {
        (document.querySelector(
          "#customRadio2"
        ) as HTMLInputElement).checked = true;
        this.fund_credit_creditclan.patchValue("1");
      }
      // this is a hack to force the change event. Since it is a combination of focus and blur.
      // i need to somehow trigger the change event to run d doCalculation function attached
      // int the template.
      (document.querySelector(
        "#validationCustom03"
      ) as HTMLInputElement).focus();
      (document.querySelector(
        "#validationCustom03"
      ) as HTMLInputElement).blur();
      // (document.querySelector(
      //   ".no_of_months_upfront"
      // ) as HTMLInputElement).dispatchEvent(new Event("change"));

      // console.log(this.arrayOfPictures);
      this.editMode = true;
      (document.getElementById("addOrEdit") as HTMLButtonElement).innerText =
        "EDIT";
    } else {
      this.createAnItemForm.reset();
      this.resetCalculation();
      (document.getElementById("addOrEdit") as HTMLButtonElement).innerText =
        "SUBMIT";
      this.resetPictures();
    }
  }

  // this function will process the form for submission
  processFormForSubmission(temp: any): FormData {
    delete temp.primary_picture;
    delete temp.secondary_picture;
    delete temp.tertiary_picture;

    let formToSubmit = new FormData();
    if (temp["fund_credit_creditclan"]) {
      formToSubmit.append("fund_option", "1");
    } else {
      formToSubmit.append("fund_option", "0");
    }
    delete temp.fund_credit_creditclan;
    delete temp.fund_credit_merchant;
    // console.log(temp);

    for (let key in temp) {
      formToSubmit.append(key, temp[key]);
    }

    this.arrayOfPictures.forEach(element => {
      let name = Object.keys(element)[0];
      formToSubmit.append(name, element[name]);
    });

    return formToSubmit;
  }

  manageResponse(
    val: { data: object; status: boolean; message: string } | any,
    form: FormGroup,
    currentForm: HTMLFormElement,
    button: HTMLButtonElement
  ) {
    const { data, message } = val;
    console.log(data);
    if (data) {
      currentForm.style.opacity = "1";
      currentForm.style.pointerEvents = "auto";
      button.innerText = "SUBMIT";
      // this.mockstore.merchantItems.push(data as MerchantItems);
      // this.arrayOfPictures = [];
      (document.getElementById("closeBtn") as HTMLButtonElement).click();

      this.mockstore.mostRecentlyAddedItem = data as MerchantItems;
      this.generalservice.singleMerchantCtrl(data as MerchantItems);
      this.generalservice.refreshCataloguesOrItems("refreshItems");
      form.reset();
      this.resetPictures();
      // incase of incasities remove all border
      currentForm
        .querySelectorAll("input")
        .forEach(element => element.classList.remove("borderRed"));
      this.editMode = false;
      if (message == "Item Edited Successfully") {
        this.generalservice.switchSidebarOnOrOff("off");
        this.generalservice.successNotification(message);
        this.creditOptions = false;
        return;
      }
      // reset calculation
      this.resetCalculation();
      this.generalservice.switchSidebarOnOrOff({
        switcher: "on",
        message: "",
        component: "view-content"
      });
    }
  }

  manageError(
    currentForm: HTMLFormElement,
    form: FormGroup,
    button: HTMLButtonElement
  ) {
    currentForm.style.opacity = "1";
    currentForm.style.pointerEvents = "auto";
    button.innerText = "SUBMIT";
    form.reset();

    this.calculate = false;
    this.editMode = false;

    // reset calculation and pictures
    this.resetCalculation();
    this.resetPictures();
  }

  get getText() {
    if (this.arrayOfPictures.length == 1) {
      this.currentPictureInView = "secondary_picture";
      return "Add second picture";
    }
    if (this.arrayOfPictures.length == 2) {
      this.currentPictureInView = "tertiary_picture";
      return "Add third picture";
    }
  }

  addMorePictures(event: Event) {
    let prevDiv: HTMLDivElement;
    let activeDiv: HTMLDivElement;

    // (document.querySelector(".icon-angle-right") as HTMLElement).click();
    if (this.arrayOfPictures.length == 1) {
      prevDiv = document.getElementById("second") as HTMLDivElement;
      prevDiv.classList.remove("active");
      activeDiv = document.getElementById("third") as HTMLDivElement;
      activeDiv.classList.add("active");
      this.activeDiv = activeDiv;
    }
    if (this.arrayOfPictures.length == 2) {
      prevDiv = document.getElementById("third") as HTMLDivElement;
      prevDiv.classList.remove("active");
      activeDiv = document.getElementById("first") as HTMLDivElement;
      activeDiv.classList.add("active");
      this.activeDiv = activeDiv;
    }
    this.trigger();
  }

  resetCalculation() {
    this.noOfMonths = 0;
    this.calculatedRemittancePerMonth = 0;
    this.calculatedUpFrontPay = 0;
    this.calculate = false;
  }
  resetPictures() {
    this.primary_picture = "https://via.placeholder.com/43";
    this.secondary_picture = "https://via.placeholder.com/44";
    this.tertiary_picture = "https://via.placeholder.com/45";
    this.arrayOfPictures = [];
  }
}
